import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  useTheme,
  useMediaQuery,
  alpha,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import img from "./images/automated-transcription-by-sonix-4e4134c959ef99b51f73867ad7295712.jpeg";
import Footer from "../Components/Footer";
import ScrollToTop from "../Components/ScrollToTop";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const Transcriptions = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const direction = ["ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ku"].includes(i18n.language) ? "right" : "left";

  return (
    <Box sx={{ direction, textAlign, minHeight: "100vh" }}>
      {/* Hero Section */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          py: { xs: 6, md: 10 },
          mt: { xs: 7, sm: 8 },
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)",
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: 32, md: 48 },
              fontWeight: 700,
              color: "white",
              textAlign: "center",
              mb: 3,
              textShadow: "0 2px 10px rgba(0,0,0,0.2)",
            }}
          >
            {t("TranscriptionSSS")}
          </Typography>
        </Container>
      </Box>

      {/* Main Content (similar style to AboutUs) */}
      <Container
        maxWidth="lg"
        sx={{ mt: { xs: 6, md: 8 }, mb: 4, px: { xs: 2, md: 4 } }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: { xs: 4, md: 6 },
            borderRadius: 4,
            background:
              "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
            border: "1px solid",
            borderColor: alpha(theme.palette.primary.main, 0.1),
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: 18, md: 22 },
              fontWeight: 400,
              lineHeight: { xs: 1.6, md: 1.8 },
              textAlign: { xs: textAlign, md: "justify" },
              color: "text.primary",
              whiteSpace: "pre-line",
              wordSpacing: { xs: "normal", md: "normal" },
            }}
          >
            {t("Transcription")}
          </Typography>
        </Paper>
      </Container>

      {/* Content Section */}
      <Container
        maxWidth="lg"
        sx={{ mt: { xs: 6, md: 8 }, mb: 8, px: { xs: 2, md: 4 } }}
      >
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            padding: { xs: 4, md: 6 },
            background:
              "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
            borderRadius: 4,
            border: "1px solid",
            borderColor: alpha(theme.palette.primary.main, 0.2),
            gap: 4,
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
              borderColor: alpha(theme.palette.primary.main, 0.4),
            },
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={img}
              alt="Automated transcription by Sonix"
              sx={{
                width: { xs: 150, md: 250 },
                height: "auto",
                borderRadius: 3,
                boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
              }}
            />
          </Box>
          <Box
            sx={{
              flex: 1,
              textAlign: { xs: "center", md: textAlign },
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", md: "flex-start" },
              gap: 3,
            }}
          >
            <Button
              variant="contained"
              size={isMobile ? "medium" : "large"}
              component={Link}
              to="/Book_now"
              sx={{
                textDecoration: "none",
                fontSize: { xs: "1rem", md: "1.2rem" },
                fontWeight: 700,
                px: { xs: 4, md: 6 },
                py: { xs: 1.5, md: 2 },
                borderRadius: 3,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(102, 126, 234, 0.6)",
                  background:
                    "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                },
              }}
            >
              Get a free quote
            </Button>
          </Box>
        </Paper>
      </Container>

      <ScrollToTop />
      <Footer />
    </Box>
  );
};

export default Transcriptions;
